/**
 * @generated SignedSource<<3df519128c4946bd27d45fad2aa94c63>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ComponentStatus = "ARCHIVED" | "DRAFT" | "PUBLISHED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ProgramCalendarComponentButtons_component$data = {
  readonly days: ReadonlyArray<boolean>;
  readonly id: string;
  readonly locked: boolean;
  readonly slug: string;
  readonly status: ComponentStatus;
  readonly " $fragmentSpreads": FragmentRefs<"WeekComponentMenu_component">;
  readonly " $fragmentType": "ProgramCalendarComponentButtons_component";
};
export type ProgramCalendarComponentButtons_component$key = {
  readonly " $data"?: ProgramCalendarComponentButtons_component$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProgramCalendarComponentButtons_component">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProgramCalendarComponentButtons_component",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WeekComponentMenu_component"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "days",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "locked",
      "storageKey": null
    }
  ],
  "type": "Component",
  "abstractKey": null
};

(node as any).hash = "c47935ea5da40044da0a90e31da68110";

export default node;
